import apiFetch from '@scale/frontend-lib/api-fetch';
import FormData from 'form-data';
import {
  DocumentOverviewData,
  DocumentQualityData,
  DocumentDataInsightsData,
  FlounderInsightsData,
} from '@scale/shared/types/documentInsights';

export interface UploadFileResult {
  taskId?: string;
  attachmentDataUrl?: string;
}

export async function uploadFromComputer(
  projectId: string,
  dataFile: File,
): Promise<UploadFileResult> {
  const formData = new FormData();
  formData.append('asset', dataFile);
  formData.append('projectId', projectId);
  const uploadFileResult = await apiFetch(null, 'internal/document/upload_from_computer', {
    method: 'POST',
    body: formData,
  });
  return uploadFileResult;
}

interface SubmitTaskRequestBody {
  project: string;
  params: Record<string, any>;
  taskId?: string;
  attachmentDataUrl?: string;
}

export interface SubmitTaskResult {
  success: boolean;
}

export async function submitDocumentTask(body: SubmitTaskRequestBody): Promise<SubmitTaskResult> {
  const submitTaskResult = await apiFetch(null, 'internal/document/submit_document_task', {
    method: 'POST',
    body,
  });
  return submitTaskResult;
}

interface DocumentDashboardOverviewResult {
  body: DocumentOverviewData;
}

export async function getDocumentOverviewInsights(
  projectId: string,
): Promise<DocumentDashboardOverviewResult> {
  const documentOverviewData = await apiFetch(null, 'internal/document/dashboard_overview', {
    method: 'POST',
    body: { projectId },
  });
  return documentOverviewData;
}

interface DocumentDashboardQualityResult {
  body: DocumentQualityData;
}

export async function getDocumentQualityInsights(
  projectId: string,
): Promise<DocumentDashboardQualityResult> {
  const documentQualityData = await apiFetch(null, 'internal/document/dashboard_quality', {
    method: 'POST',
    body: { projectId },
  });
  return documentQualityData;
}

interface DocumentDashboardDataInsightsResult {
  body: DocumentDataInsightsData | FlounderInsightsData;
}

export async function getDocumentDataInsights(
  projectId: string,
): Promise<DocumentDashboardDataInsightsResult> {
  const documentDataInsightsData = await apiFetch(
    null,
    'internal/document/dashboard_datainsights',
    {
      method: 'POST',
      body: { projectId },
    },
  );
  return documentDataInsightsData;
}

export async function maybeSendDovePostprocessedJson(
  batchId: string,
  enforceBatchSize: boolean,
): Promise<void> {
  await apiFetch(null, `internal/document/dove_send_postprocessed_json`, {
    method: 'POST',
    body: { batchId, enforceBatchSize },
  });
}
